module.exports = __webpack_public_path__ + "static/Italmatch-chemicals-03a50a2c2d597ee06ddc55d307b469eb.png";